import { render, staticRenderFns } from "./BarConsultationsISTByTranchesAge.vue?vue&type=template&id=38563a20&"
import script from "./BarConsultationsISTByTranchesAge.vue?vue&type=script&lang=ts&"
export * from "./BarConsultationsISTByTranchesAge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports